import React from 'react';
import PropTypes from 'prop-types';
import { MessageAlert } from '../../typography/Message';
import { FormGroupWrapper, CheckboxsWrapper, SubLabel } from './styles';
import Checkbox from '../Checkbox';

const FormCheckGroup = ({
  radio,
  name,
  style,
  inline,
  options,
  onBlur,
  handleBlur,
  onKeyDown,
  noMargin,
  testid,
  // formik
  values,
  errors,
  touched,
  onItemChange,
  setFieldValue,
}) => {
  const error = !!errors[name] && !!touched[name];
  const totalOptions = options.length;
  return (
    <FormGroupWrapper noMargin={noMargin} style={style} role="group" aria-labelledby={`${name}0`}>
      <CheckboxsWrapper inline={inline}>
        {options.map(({ value, label, disabled, subLabel }, i) => (
          <React.Fragment key={value}>
            <Checkbox
              testid={`${testid}-${i}`}
              style={
                !subLabel && !error && i === totalOptions - 1 ? { marginBottom: 0 } : undefined
              }
              radio={radio}
              disabled={disabled}
              id={`${name}${i}`}
              name={name}
              label={label}
              value={value}
              checked={
                radio
                  ? value === values[name]
                  : !!(values[name] || '').split(',').find(a => a === value)
              }
              onBlur={onBlur || handleBlur}
              onKeyDown={onKeyDown}
              onChange={e => {
                const { checked } = e.target;
                if (onItemChange) {
                  onItemChange(value, checked);
                  return;
                }
                if (radio) {
                  if (checked) setFieldValue(name, value);
                } else {
                  let v = values[name] || '';
                  v = v.split(',').filter(a => !!a);
                  v = v.filter(a => a !== value);
                  if (checked) v.push(value);
                  setFieldValue(name, v.join(','));
                }
              }}
            />
            {subLabel && <SubLabel disabled={disabled}>{subLabel}</SubLabel>}
          </React.Fragment>
        ))}
      </CheckboxsWrapper>
      {error ? <MessageAlert>{errors[name]}</MessageAlert> : null}
    </FormGroupWrapper>
  );
};

FormCheckGroup.propTypes = {
  noMargin: PropTypes.bool,
  radio: PropTypes.bool,
  style: PropTypes.object,
  options: PropTypes.array,
  name: PropTypes.string,
  testid: PropTypes.string,
  inline: PropTypes.bool,
  onBlur: PropTypes.func,
  handleBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  // formik
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  onItemChange: PropTypes.func,
  setFieldValue: PropTypes.func,
};

FormCheckGroup.defaultProps = {
  errors: {},
  values: {},
  touched: {},
  setFieldValue: () => {},
};

export default FormCheckGroup;
